export const primaryColor = '#1B1B1B';

export const secondaryColor = '#666666';

export const accentColor = '#EC6C0C';

export const lightGrey = '#E5E5E5';

export const inactiveGrey = '#A0A0A0';

export const successGreen = '#56B913';
